<template>
<div style="height:100vh">
    <Sidebar title="Logis du Chateau" appartement="/logisduchateau" link="https://www.airbnb.fr/rooms/36438518"/>
    
    <div class="d-flex flex-wrap justify-content-center m- h-75">
        
            <panel text='Visite virtuelle' img='3d.png'/>
            <panel text='Que faire à proximité ?' img='ville.png' url="chateau/gaillon"/>
       
            
    </div>
    
</div>
    
</template>

<script>
import Sidebar from '../components/Sidebar'
import panel from '../components/Panel-appartement'
export default {
    name : 'Chateau',
    components : {
        Sidebar,
        panel
    },
    metaInfo() {
        return { 
            title: "Le Logis du Chateau - Location Normandie",
            meta: [
                { name: 'description', content:  'A 92 kms de Paris, vous avez aimé le Logis des clos à Aubevoye, vous adorerez le Logis du château, situé à 2 minutes à pieds, dans le quartier historique de Gaillon. Charmante petite maison de ville fraîchement rénovée de 100m2 avec...'},
                { property: 'og:title', content: "Le Logis du Chateau - Location Normandie"},
                { property: 'og:site_name', content: 'Le Logis du Chateau'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    },
    
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap');
body {
    background-color: burlywood!important;
    background-image: none!important;
}
div {
    font-family: 'Indie Flower', cursive;
    font-size: 20px;
}
</style>